export default __webpack_public_path__ + "static/media/relay_report.d9dcb2e0.png";